import { render, staticRenderFns } from "./DetailsTicketStatusCommentBox.vue?vue&type=template&id=9f9bc5d0"
import script from "./DetailsTicketStatusCommentBox.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketStatusCommentBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports